/* eslint-disable no-nested-ternary */
import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/lib/utils";
import "@/components/ui/gradient-button.css";

interface GradientButtonProps extends ComponentProps<"button"> {
  icon?: ReactNode | "arrow" | "none";
  fullWidth?: boolean;
}

const ArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 14 14"
    fill="none"
    className="gradient-button__arrow"
    aria-hidden="true"
  >
    <path
      d="M2 7h10M8 3l4 4-4 4"
      stroke="white"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GradientButton = ({
  children,
  icon = "arrow",
  fullWidth = true,
  className,
  type = "button",
  ...props
}: GradientButtonProps) => {
  const iconNode =
    icon === "arrow" ? <ArrowIcon /> : icon === "none" ? null : icon;

  return (
    <button
      type={type}
      className={cn(
        "gradient-button",
        fullWidth && "gradient-button--full",
        className
      )}
      {...props}
    >
      <span className="gradient-button__shimmer" aria-hidden="true" />
      <span className="gradient-button__label">{children}</span>
      {iconNode}
    </button>
  );
};
